var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseList',{attrs:{"list-query":_vm.list,"name-map":_vm.nameMap,"sort":_vm.sort,"route":"crossform","locale-section":"pages.crossForms"},scopedSlots:_vm._u([{key:"extra",fn:function({ element: { aspect, form } }){return [_c('img',{staticClass:"list-image",attrs:{"src":// FIXME: make url configurable, store images locally?
        `https://www.runinskrifter.net/img/crosses/${aspect}/${aspect}${form}.png`}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }